//campos cep e uf fora do padrão verificar com Back-end
export interface IEntrepreneur {
  id?: number;
  uuid?: string;
  name: string  
  document: string   
  city: string
  state: string
  street_name: string
  number: string
  district: string
  complement: string
  zip_code: string 
  address?:{
  city?: string,
  state?: string,
  street_name?: string,
  number?: string,
  district?: string,
  complement?: string,
  zip_code?: string 
  }
}


export const entrepreneurInitValues: IEntrepreneur = {
 //id: 0,
  name: '',  
  document: '',
  city: '',
  state: '',
  street_name: '',
  number: '',
  district: '',
  complement: '',
  zip_code: '',
  
}

